import { Button } from "antd";
import styled from "styled-components";
import { color } from "../../res/colors";

export const GreenButton = styled(Button)`
  border-radius: 8px;
  background: ${color.THEME};
  border-color: ${color.THEME};
  width: ${(p) => (p.width ? p.width : "100%")} !important;

  height: 32px;
  color: ${color.WHITE};
  &:hover {
    opacity: 0.8;
    background: ${color.THEME};
    border-color: ${color.THEME};
    color: ${color.WHITE};
  }
  &:focus {
    background: ${color.THEME};
    color: ${color.WHITE};
    opacity: 0.8;
  }
`;
